// Images are in public folder, use absolute paths
import type { ReactNode } from 'react'
import MainContent from '@/components/public/MainContent'
import Aside from '@/components/public/Aside'

export default function PageSection({
	children,
	showAside = true,
}: {
	children: ReactNode
	showAside?: boolean
}) {
	return (
		<section className="flex min-h-svh">
			<MainContent showAside={showAside}>{children}</MainContent>
			{showAside ? <Aside /> : null}
		</section>
	)
}
